import styled from "styled-components";

export const MainContainer = styled.div`
  .slick-slider.center.slick-initialized {
    margin: auto !important;
    max-width: 1180px !important;
    background: #d8d8d8 !important;
    height: 400px !important;
    margin-bottom: 100px;
  }
  .slick-prev:before {
    color: black !important;
  }
  .slick-prev:before,
  .slick-next:before {
    color: black !important;
    box-shadow: 0px 3px #00000029;
    border-radius: 50%;
  }
  .sc-fctJkW.cKXbes {
    min-height: 350px !important;
  }
  @media (max-width: 390px) {
    .slick-slider.slick-initialized .slick-prev {
      left: -10px !important;
    }
    .slick-slider.slick-initialized .slick-next {
      right: -10px !important;
    }
  }
`;
export const Container = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  overflow: hidden;
  @media (max-width: 390px) {
    padding: 25px;
  }
`;
export const IMainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InnerTopContainer = styled.div``;

export const Heading = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 390px) {
    font-size: 40px;
  }
`;
export const Description = styled.p`
  font-size: 32px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 390px) {
    font-size: 24px;
  }
`;

export const BottomContainer = styled.div`
  /* display: flex;
  flex-direction: row; */
  margin-top: 50px;
  margin-left: 216px;
  margin-right: 216px;
  @media (max-width: 786px) {
    margin-top: 20px;
  margin-left: 100px;
  margin-right: 100px;
  }
  @media (max-width: 550px) {
    margin-top: 16px;
  margin-left: 30px;
  margin-right: 30px;
  }
`;
export const InnerBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const SliderImageContainer = styled.div`
  display: flex !important;
  flex-wrap: wrap !important;
  width: 500px;
  height: 380px;
  @media (max-width: 786px) {
    height: 250px;
  }
  justify-content: center;
  align-items: center;
  gap: 15px;
  img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    flex-basis: calc(25% - 30px);
  }
`;
